// extracted by mini-css-extract-plugin
module.exports = {"select":"Select_select__hhi0_","selectError":"Select_selectError__3GUux"};